/* eslint-disable new-cap */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';

const SectionHeader = ({
  title,
  hasSelection,
  actionLabel,
  onAction,
  showActions = false,
  onDownloadPDF,
  displayTitle,
}) => {
  const handleDownloadPDF = () => onDownloadPDF?.();

  return (
    <div className="breadcrumb-extra-row">
      <div className="breadcrumb-report">{displayTitle ?? title}</div>

      {showActions && (
        <div className="breadcrumb-extra-right">
          <div className="potential-download-button">
            <button type="button" onClick={handleDownloadPDF}>
              <span className="downloadText">Download as</span>
              <span className="pdfText">.pdf</span>
            </button>
          </div>
          <div className="potential-duplicate-button">
            <button type="button" disabled={!hasSelection} onClick={onAction}>
              {actionLabel}
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

SectionHeader.propTypes = {
  title: PropTypes.string.isRequired,
  hasSelection: PropTypes.bool,
  actionLabel: PropTypes.string,
  onAction: PropTypes.func,
  showActions: PropTypes.bool,
  onDownloadPDF: PropTypes.func,
  displayTitle: PropTypes.string,
};

export default SectionHeader;
